// utils

// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
  DOCS: '/docs',
  SUPPORT: '/support',
  LEGAL: '/legal',
  ARTICLES: '/articles',
};

// ----------------------------------------------------------------------

export const paths = {
  /* to be changed &checked if really needed */
  comingSoon: '/coming-soon',
  page403: '/403',
  page500: '/500',
  components: '/components',

  /* to be changed */

  trust: '/trust',
  maintenance: '/maintenance',
  page404: '/404',

  auth: {
    firebase: {
      login: `${ROOTS.AUTH}/firebase/login`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      register: `${ROOTS.AUTH}/firebase/register`,
      forgotPassword: `${ROOTS.AUTH}/firebase/forgot-password`,

      // mfa
      verifyUserCode: `${ROOTS.AUTH}/firebase/mfa/verify-user-code`,
      verifyUserOtpCode: `${ROOTS.AUTH}/firebase/mfa/verify-user-otp-code`,
      selectSecondVerification: `${ROOTS.AUTH}/firebase/mfa/select-second-verification`,
      secondFactorRecovery: `${ROOTS.AUTH}/firebase/mfa/second-factor-recovery`,
      checkSecondFactorRecovery: `${ROOTS.AUTH}/firebase/mfa/check-second-factor-recovery`,

      //
      manageConsent: `${ROOTS.AUTH}/firebase/consent/manage-consent`,
    },
  },

  // SUPPORT
  supportPath: {
    root: ROOTS.SUPPORT,
    faqs: `${ROOTS.SUPPORT}/faqs`,
    contact: `${ROOTS.SUPPORT}/contact-us`,
  },

  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    productLibrary: `${ROOTS.DASHBOARD}/product-library`,
    metadataTranslator: `${ROOTS.DASHBOARD}/metadataTranslator`,
    promptBuilder: `${ROOTS.DASHBOARD}/promptBuilder`,
    jobs: `${ROOTS.DASHBOARD}/jobs`,
    metadataTranslateJob: `${ROOTS.DASHBOARD}/MTJobs`,
    metadataTranslateJobDetails: `${ROOTS.DASHBOARD}/MTJobDetails`,
    companyInformation: `${ROOTS.DASHBOARD}/companyInformation`,
    glossary: `${ROOTS.DASHBOARD}/glossary`,
    credentials: `${ROOTS.DASHBOARD}/credentials`,
    approval: `${ROOTS.DASHBOARD}/approval`,
    log: `${ROOTS.DASHBOARD}/Logs`,
    translationEngine: `${ROOTS.DASHBOARD}/translationEngine`,
    aiEngines: `${ROOTS.DASHBOARD}/aiEngines`,
    aiCommandCenter: `${ROOTS.DASHBOARD}/aiCommandCenter`,
    agentTemplates: `${ROOTS.DASHBOARD}/agent-templates`,
    security: `${ROOTS.DASHBOARD}/security`,
    group: {
      root: `${ROOTS.DASHBOARD}/group`,
    },
    user: {
      root: `${ROOTS.DASHBOARD}/user`,
      list: `${ROOTS.DASHBOARD}/user`,
      account: `${ROOTS.DASHBOARD}/user/account`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/user/${id}/edit`,
    },
  },

  // LEGAL
  legal: {
    root: ROOTS.LEGAL,
    legalDisclosure: `${ROOTS.LEGAL}/legal-disclosure`,
    disclaimer: `${ROOTS.LEGAL}/disclaimer`,
    eeaStandardContactualClauses: `${ROOTS.LEGAL}/eea-standard-contractual-clauses`,
    cookiePolicy: `${ROOTS.LEGAL}/cookie-policy`,
    privacyPolicy: `${ROOTS.LEGAL}/privacy-policy`,
    dataProcessingAgreement: `${ROOTS.LEGAL}/data-processing-agreement`,
    termsOfService: `${ROOTS.LEGAL}/terms-of-service`,
    serviceLevelAgreement: `${ROOTS.LEGAL}/service-level-agreement`,
  },

  // DOCS
  docs: {
    root: ROOTS.DOCS,
    overview: `${ROOTS.DOCS}/overview`,
    user: {
      root: `${ROOTS.DOCS}/user`,
      roles: `${ROOTS.DOCS}/user/roles`,
      register: `${ROOTS.DOCS}/user/register`,
      invite: `${ROOTS.DOCS}/user/invite`,
      passwordReset: `${ROOTS.DOCS}/user/passwordReset`,
      twoFactorAuthentication: `${ROOTS.DOCS}/user/twoFactorAuthentication`,
    },
    setup: {
      root: `${ROOTS.DOCS}/setup`,
      setupApproval: `${ROOTS.DOCS}/setup/approval`,
      orgCredentials: `${ROOTS.DOCS}/setup/orgCredentials`,
      translationEngine: `${ROOTS.DOCS}/setup/translationEngine`,
      glossary: `${ROOTS.DOCS}/setup/glossary`,
      notifications: `${ROOTS.DOCS}/setup/notifications`,
    },
    translationWorkbench: {
      root: `${ROOTS.DOCS}/translationWorkbench`,
      retrieveMetadata: `${ROOTS.DOCS}/translationWorkbench/retrieveMetadata`,
      filterMetadata: `${ROOTS.DOCS}/translationWorkbench/filterMetadata`,
      deployMetadata: `${ROOTS.DOCS}/translationWorkbench/deployMetadata`,
      translateMetadata: `${ROOTS.DOCS}/translationWorkbench/translateMetadata`,
      limit: `${ROOTS.DOCS}/translationWorkbench/limit`,
      tokenHistory: `${ROOTS.DOCS}/translationWorkbench/tokenHistory`,
    },
    MTJob: {
      root: `${ROOTS.DOCS}/MTJob`,
      createUpdateJob: `${ROOTS.DOCS}/MTJob/createUpdateJob`,
      status: `${ROOTS.DOCS}/MTJob/status`,
      compareOrgs: `${ROOTS.DOCS}/MTJob/compareOrgs`,
      orgsDeployment: `${ROOTS.DOCS}/MTJob/orgsDeployment`,
    },
    salesforce: {
      root: `${ROOTS.DOCS}/salesforce`,
      setup: `${ROOTS.DOCS}/salesforce/setup`,
      components: `${ROOTS.DOCS}/salesforce/components`,
      translate: `${ROOTS.DOCS}/salesforce/components/translate`,
      detectLanguage: `${ROOTS.DOCS}/salesforce/components/detectLanguage`,
      authenticationSalesforce: `${ROOTS.DOCS}/salesforce/setup/authenticationSalesforce`,
      emailAI: `${ROOTS.DOCS}/salesforce/components/emailAI`,
      installPackage: `${ROOTS.DOCS}/salesforce/setup/installPackage`,
      editRecordPage: `${ROOTS.DOCS}/salesforce/setup/editRecordPage`,
      n8nSetup: `${ROOTS.DOCS}/salesforce/setup/n8n-setup`,
      caseCommentAI: `${ROOTS.DOCS}/salesforce/components/caseCommentAI`,
      recordAI: `${ROOTS.DOCS}/salesforce/components/recordAI`,
      fileAI: `${ROOTS.DOCS}/salesforce/components/fileAI`,
      aiService: `${ROOTS.DOCS}/salesforce/components/aiService`,
      flowSTConfiguration: `${ROOTS.DOCS}/salesforce/setup/flowSTConfiguration`,
      stCiCdComponent: `${ROOTS.DOCS}/salesforce/components/stCiCdComponent`,
      stJsonParser: `${ROOTS.DOCS}/salesforce/components/stJsonParser`,
      aiAsyncResponseCheck: `${ROOTS.DOCS}/salesforce/components/aiAsyncResponseCheck`,
      chatbotAIAgent: `${ROOTS.DOCS}/salesforce/components/aiAgent`,
      feedback: `${ROOTS.DOCS}/salesforce/components/feedback`,


    },
    openAPIs: {
      root: `${ROOTS.DOCS}/openAPIs`,
      token: `${ROOTS.DOCS}/openAPIs/token`,
    },
    simpleTAI: {
      root: `${ROOTS.DOCS}/simpleTAI`,
      promptBuilderGuide: `${ROOTS.DOCS}/simpleTAI/promptBuilderGuide`,
      aiCommandCenterGuide: `${ROOTS.DOCS}/simpleTAI/aiCommandCenterGuide`,
      llmManagerGuide: `${ROOTS.DOCS}/simpleTAI/llmManagerGuide`,
    },
    billing: {
      root: `${ROOTS.DOCS}/billing`,
      guide: `${ROOTS.DOCS}/billing/guide`,
    }
  },

  // ARTICLES
  articles: {
    root: ROOTS.ARTICLES,
    translateFast: `${ROOTS.ARTICLES}/translate-fast-with-simple-translate`,
    stVsSalesforceTranslation: `${ROOTS.ARTICLES}/salesforce-translation-vs-simple-translate`,
    availableMetadata: `${ROOTS.ARTICLES}/available-metadata-in-simple-translate`,
    getStartedWithSt: `${ROOTS.ARTICLES}/get-started-with-simple-translate`,
    howToSetupSt: `${ROOTS.ARTICLES}/how-to-setup-simple-translate`,
    simpletChatAssistant: `${ROOTS.ARTICLES}/simplet-chat-assistant`,
    promptBuilderVisualAI: `${ROOTS.ARTICLES}/prompt-builder-visual-ai-integration`,
    translationApprovalDisasters: `${ROOTS.ARTICLES}/translation-approval-disasters`,
    simpleTAIComponentsPerformance: `${ROOTS.ARTICLES}/simplet-ai-components-performance`,
    aiCommandCenter: `${ROOTS.ARTICLES}/ai-command-center`,
    simpleTAIUseCaseTracking: `${ROOTS.ARTICLES}/simplet-ai-use-case-tracking`,
    smartCaseComment: `${ROOTS.ARTICLES}/smart-case-comment`,
    aiAgent: `${ROOTS.ARTICLES}/ai-agent`,
    simpleEmailAI: `${ROOTS.ARTICLES}/simple-email-ai`,
    fileAI: `${ROOTS.ARTICLES}/file-ai`,
    recordAI: `${ROOTS.ARTICLES}/record-ai`,
    aiService: `${ROOTS.ARTICLES}/ai-service`,
    detectLanguage: `${ROOTS.ARTICLES}/detect-language`,
    simpleTTranslate: `${ROOTS.ARTICLES}/simplet-translate`,

    simpleTAIAgentsPerformance: `${ROOTS.ARTICLES}/simplet-ai-agents-performance`,

    simpleTLLMsHandler: `${ROOTS.ARTICLES}/simple-t-llms-handler-one-dashboard`,
    // n8n dynamic agent templates
    n8nAgentTemplate: (id: string) => `${ROOTS.ARTICLES}/n8n/${id}`,
  },
};
